export enum OnboardingSteps {
    personalDetails = 1,
    verifyPhone = 2,
    createPassword = 3
}

export const GET_STARTED_ERRORS_MAP = {
  CUSTOMER_NOT_FOUND: 4003,
  AUTHORIZED_USER_NOT_FOUND: 50720, // Move to Error page with case CANCEL - need text
  AUTHORIZED_USER_ALREADY_REGISTER: 50724,
  AUTHORIZED_USER_INVITE_EXPIRED: 50723, // Move to Error page with case EXPIRED - Ready
  AUTHORIZED_USER_INVITE_CANCELED: 50722, // Move to Error page with case CANCEL - need text
  AUTHORIZED_USER_ALREADY_COMPLETE_ONBOARDING: 50711,
  AUTHORIZED_USER_ALREADY_COMPLETE_ONBOARDING_2: 50725,
};
